import { useNavigate } from 'react-router-dom';
import { useAuth } from '../authentication/AuthContext';
import { useState } from 'react'; // Add this import at the top
import '../styles/BetaPage.css';
import { event } from '../services/analyticsService';
import '../styles/AccountPage.css'; // Import the AccountPage styles

function BetaPage() {
  const navigate = useNavigate();
  const { isAdmin, hasActiveSubscription, user } = useAuth();
  const [betaEmail, setBetaEmail] = useState('');
  const [betaMessage, setBetaMessage] = useState({ text: '', isError: false });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleGetStarted = () => {
    // Track free plan selection
    event({
      action: 'select_plan',
      category: 'pricing',
      label: 'free_plan',
      value: 0
    });
    
    // Check if user is authenticated
    if (!user) {
      navigate('/login', { 
        state: { 
          from: '/research',
          message: 'Please log in to access the app and start your research'
        } 
      });
      return;
    }
    
    navigate('/research');
  };

  // In your PricingPage.js handleBetaSubmit function:
  const handleBetaSubmit = async (e) => {
    e.preventDefault();
    
    if (!betaEmail) {
      setBetaMessage({ 
        text: 'Please enter your email address.', 
        isError: true 
      });
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      // Get the API URL from environment variables
      const API_URL = process.env.REACT_APP_API_URL || '';

      // 1. First send to your server for Cognito registration
      const serverResponse = await fetch(`${API_URL}/user/beta-access-request`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: betaEmail })
      });
      
      if (!serverResponse.ok) {
        throw new Error('Server request failed');
      }
      
      // 2. Also send directly to Google script for immediate logging
      // (this is a backup in case the server part fails)
      const formData = new FormData();
      formData.append('Email', betaEmail);
      formData.append('formType', 'beta');
      formData.append('Source', 'website_beta_form');
      
      // Add UTM parameters if available
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('utm_source')) formData.append('UTM Source', urlParams.get('utm_source'));
      if (urlParams.get('utm_medium')) formData.append('UTM Medium', urlParams.get('utm_medium'));
      if (urlParams.get('utm_campaign')) formData.append('UTM Campaign', urlParams.get('utm_campaign'));
      
      await fetch('https://script.google.com/macros/s/AKfycbzZQKuPxjTsMcl6SHWP0OJ8YlxTIR-s0PQHlMHoWTrUi7ofCdIKcqEPu5Axa-fX8lv2ug/exec', {
        method: 'POST',
        body: formData
      });
      
      setBetaMessage({ 
        text: 'Thank you for your interest! We will be in touch soon.', 
        isError: false 
      });
      setBetaEmail('');
      
      // Track the event with analytics
      event({
        action: 'beta_signup',
        category: 'acquisition',
        label: 'pricing_page',
      });
    } catch (error) {
      console.error('Signup error:', error);
      setBetaMessage({ 
        text: 'Something went wrong. Please try again later.', 
        isError: true 
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSubscribe = () => {
    // Track subscription plan selection
    event({
      action: 'select_plan',
      category: 'pricing',
      label: 'subscription_plan',
      value: 20
    });
    
    // Check if user is authenticated
    if (!user) {
      navigate('/login', { 
        state: { 
          from: '/account',
          message: 'Please log in to access the app and subscribe to a plan'
        } 
      });
      return;
    }
    
    // Navigate to account page with subscription flag
    navigate('/account', { state: { subscribe: true } });
  };

  const handleManageSubscription = () => {
    // Track manage subscription click
    event({
      action: 'manage_subscription',
      category: 'account',
      label: 'from_pricing_page'
    });
    
    navigate('/account');
  };

  return (
    <div className="account-page">
      <div className="account-container">
        {/*
        <h1 className="account-title">Simple, Transparent Pricing</h1>
        <p style={{ textAlign: "center", marginBottom: "2rem", color: "#555", fontSize: "1.2rem" }}>
          Choose the plan that fits your research needs
        </p>

        <div className="pricing-cards" style={{ display: "flex", gap: "2rem", justifyContent: "center", flexWrap: "wrap" }}>

          {/* Free Plan Card */}{/*
          <div className="account-card" style={{ 
            flex: "1",
            minWidth: "300px", 
            maxWidth: "450px",
            textAlign: "center",
            position: "relative",
            overflow: "hidden",
            transition: "transform 0.3s ease, box-shadow 0.3s ease",
            cursor: "pointer"
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = "translateY(-5px)";
            e.currentTarget.style.boxShadow = "0 10px 30px rgba(0,0,0,0.12)";
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 2px 10px rgba(0,0,0,0.08)";
          }}>
            <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: "6px", background: "linear-gradient(135deg, white, var(--secondary-color))" }}></div>
            
            <h2 style={{ color: "var(--tertiary-color)", fontSize: "1.6rem", marginBottom: "0.5rem" }}>Free Plan</h2>
            <p style={{ fontSize: "2.5rem", fontWeight: "bold", margin: "1rem 0 0" }}>€0<span style={{ fontSize: "1rem", color: "#777", fontWeight: "normal" }}>/month</span></p>
            
            <div style={{ 
              margin: "1.5rem 0",
              padding: "1.5rem",
              background: "linear-gradient(135deg, rgba(100, 148, 112, 0.05), rgba(224, 240, 228, 0.15))",
              borderRadius: "8px"
            }}>
              <ul style={{ 
                textAlign: "left", 
                paddingLeft: "1.5rem",
                color: "#444",
                lineHeight: "1.8"
              }}>
                <li>3 research credits per week</li>
                <li>Up to 10 questions per research</li>
                <li>Up to 20 personas per research</li>
                <li>Basic analytics dashboard</li>
                <li>Basic e-mail support</li>
              </ul>
            </div>
            
            <button 
              onClick={handleGetStarted}
              style={{ 
                padding: "14px 28px", 
                boxShadow: "0 6px 12px rgba(0,0,0,0.15)",
                transition: "all 0.3s ease",
                background: "linear-gradient(135deg, white, var(--secondary-color))",
                color: "#333",
                fontWeight: "bold",
                fontSize: "1.1rem",
                transform: "translateY(0)",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                width: "100%"
              }}
              onMouseOver={(e) => e.currentTarget.style.transform = "translateY(-3px)"}
              onMouseOut={(e) => e.currentTarget.style.transform = "translateY(0)"}
            >
              Start Free
            </button>
          </div>

          {/* Premium Plan Card */}{/*
          <div className="account-card" style={{ 
            flex: "1",
            minWidth: "300px", 
            maxWidth: "450px",
            textAlign: "center",
            position: "relative",
            overflow: "hidden",
            transition: "transform 0.3s ease, box-shadow 0.3s ease",
            cursor: "pointer",
            border: hasActiveSubscription ? "2px solid var(--tertiary-color)" : "1px solid #eee"
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = "translateY(-5px)";
            e.currentTarget.style.boxShadow = "0 10px 30px rgba(0,0,0,0.12)";
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 2px 10px rgba(0,0,0,0.08)";
          }}>
            <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: "6px", background: "linear-gradient(135deg, var(--tertiary-color), var(--secondary-color))" }}></div>
            
            {hasActiveSubscription && (
              <div style={{
                position: "absolute",
                top: "35px",
                right: "-55px",
                transform: "rotate(45deg)",
                backgroundColor: "var(--tertiary-color)",
                color: "white",
                padding: "4px 55px",
                fontSize: "0.8rem",
                fontWeight: "bold"
              }}>
                CURRENT PLAN
              </div>
            )}
            
            <h2 style={{ color: "var(--tertiary-color)", fontSize: "1.6rem", marginBottom: "0.5rem" }}>Premium Plan</h2>
            <p style={{ fontSize: "2.5rem", fontWeight: "bold", margin: "1rem 0 0" }}>€20<span style={{ fontSize: "1rem", color: "#777", fontWeight: "normal" }}>/month</span></p>
            
            <div style={{ 
              margin: "1.5rem 0",
              padding: "1.5rem",
              background: "linear-gradient(135deg, rgba(100, 148, 112, 0.1), rgba(224, 240, 228, 0.3))",
              borderRadius: "8px"
            }}>
              <ul style={{ 
                textAlign: "left", 
                paddingLeft: "1.5rem",
                color: "#444",
                lineHeight: "1.8"
              }}>
                <li>10 research credits per week</li>
                <li>Up to 15 questions per research</li>
                <li>Up to 100 personas per research</li>
                <li>Advanced analytics dashboard</li>
                <li>Priority support</li>
              </ul>
            </div>
            
            <button 
              onClick={hasActiveSubscription ? handleManageSubscription : handleSubscribe}
              style={{ 
                padding: "14px 28px", 
                boxShadow: "0 6px 12px rgba(0,0,0,0.15)",
                transition: "all 0.3s ease",
                background: "linear-gradient(135deg, var(--tertiary-color), var(--secondary-color))",
                color: "white",
                fontWeight: "bold",
                fontSize: "1.1rem",
                transform: "translateY(0)",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                width: "100%"
              }}
              onMouseOver={(e) => e.currentTarget.style.transform = "translateY(-3px)"}
              onMouseOut={(e) => e.currentTarget.style.transform = "translateY(0)"}
            >
              {hasActiveSubscription ? 'Manage Subscription' : 'Subscribe Now'}
            </button>
          </div>
        </div>

        <div className="account-card" style={{ textAlign: "center", marginTop: "2rem" }}>
          <h3 style={{ color: "var(--tertiary-color)", marginBottom: "1rem" }}>Need Higher Limits?</h3>
          <p style={{ marginBottom: "1.5rem" }}>
            For businesses requiring advanced features, higher limits, or custom integrations
          </p>
          <a 
            href="mailto:business@instantflows.com"
            style={{ 
              display: "inline-block",
              padding: "12px 24px",
              background: "white",
              color: "var(--tertiary-color)",
              border: "1px solid var(--tertiary-color)",
              borderRadius: "6px",
              fontWeight: "600",
              textDecoration: "none",
              transition: "all 0.3s ease"
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.background = "var(--tertiary-color)";
              e.currentTarget.style.color = "white";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.background = "white";
              e.currentTarget.style.color = "var(--tertiary-color)";
            }}
          >
            Contact Enterprise Sales
          </a>
        </div>

        {isAdmin && (
          <div className="account-card" style={{ marginTop: "2rem", background: "#f7f9fc" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
              <div style={{ 
                background: "#3b82f6", 
                color: "white", 
                width: "40px", 
                height: "40px", 
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "1.2rem",
                fontWeight: "bold"
              }}>A</div>
              <div>
                <h3 style={{ margin: "0 0 0.25rem", color: "#3b82f6" }}>Admin Account</h3>
                <p style={{ margin: 0 }}>You have unlimited access to all features. 20 questions and 200 personas max per research.</p>
              </div>
            </div>
          </div>
        )} */}
        <div className="beta-section" style={{ 
          textAlign: "center", 
          padding: "3rem 1rem",
          maxWidth: "800px",
          margin: "0 auto"
        }}>
          <h1 className="account-title">Now in beta</h1>
          <p style={{ 
            textAlign: "center", 
            marginBottom: "2rem", 
            color: "#555", 
            fontSize: "1.2rem" 
          }}>
            Request access to be one of the first to experience InstantFlows.
          </p>
          
          <div style={{ 
            display: "flex", 
            flexDirection: "column", 
            alignItems: "center",
            gap: "1.5rem",
            maxWidth: "500px",
            margin: "0 auto"
          }}>
            <div style={{ 
              width: "100%", 
              display: "flex", 
              flexDirection: "column", 
              gap: "1rem",
              background: "white",
              padding: "2rem",
              borderRadius: "12px",
              boxShadow: "0 2px 10px rgba(0,0,0,0.08)"
            }}>
              <input 
                type="email" 
                placeholder="Enter your email address" 
                value={betaEmail}
                onChange={(e) => setBetaEmail(e.target.value)}
                style={{
                  padding: "14px",
                  borderRadius: "6px",
                  border: "1px solid #ddd",
                  fontSize: "1rem",
                  width: "100%",
                  boxSizing: "border-box"
                }}
              />

              <button 
                onClick={handleBetaSubmit}
                disabled={isSubmitting}
                style={{ 
                  padding: "14px 28px", 
                  background: isSubmitting ? "#aaa" : "var(--tertiary-color)",
                  color: "white",
                  border: "none",
                  borderRadius: "6px",
                  fontWeight: "600",
                  fontSize: "1rem",
                  cursor: isSubmitting ? "default" : "pointer",
                  transition: "all 0.3s ease",
                  width: "100%"
                }}
                onMouseOver={(e) => {
                  if (!isSubmitting) {
                    e.currentTarget.style.background = "var(--darker-color)";
                  }
                }}
                onMouseOut={(e) => {
                  if (!isSubmitting) {
                    e.currentTarget.style.background = "var(--tertiary-color)";
                  }
                }}
              >
                {isSubmitting ? 'Submitting...' : 'Request Access'}
              </button>

              {betaMessage.text && (
                <div 
                  style={{
                    marginTop: "10px",
                    color: betaMessage.isError ? "red" : "#4CAF50",
                    fontSize: "0.9rem",
                    textAlign: "center"
                  }}
                >
                  {betaMessage.text}
                </div>
              )}
            
            <p style={{ 
              fontSize: "0.9rem", 
              color: "#777",
              
            }}>
              We're currently in beta testing. Join to get access and help shape the future of InstantFlows.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  );
}

export default BetaPage;